import { Route } from "react-router-dom";

import { JobOrder, JobOrderAccess, JobOrderManage,JobOrderView } from "../pages/ERP/joborder";
import {
    PurchaseOrder,
    PurchaseOrderAccess,
    PurchaseOrderManage,
    PurchaseOrderView
} from "../pages/ERP/purchase-order";
import {
    GoodsReceipt,
    GoodsReceiptAccess,
    GoodsReceiptManage,
    GoodsReceiptQc,
    GoodsReceiptTags,
    GoodsReceiptView,
    GoodsReceiptAiScan
} from "../pages/ERP/goods-receipt";
import { PDOrder, PDAccess, PDManage,PDView } from "../pages/ERP/product-order";
import { DeliveryNote, DeliveryNoteAccess, DeliveryNoteManage } from "../pages/ERP/delivery-note";
import { PackingList, PackingListAccess, PackingListManage } from "../pages/ERP/packing-list";
import { Invoice, InvoiceAccess, InvoiceManage } from "../pages/ERP/invoice";
import { ShipmentPlan, ShipmentPlanAccess, ShipmentPlanManage } from "../pages/ERP/shipment-plan";
import { Requisition, RequisitionAccess, RequisitionManage } from "../pages/ERP/requisition";
import { FgHandover, FgHandoverAccess, FgHandoverManage } from "../pages/ERP/fg-handover";
import { Ju, JuAccess, JuManage } from "../pages/ERP/ju";
import { FxRate, FxRateAccess } from "../pages/ERP/fx-rate";
import { Proforma, ProformaAccess, ProformaManage } from "../pages/ERP/proforma";

export const ERPRouter = (
  <>
    <Route path="/ERP/job-order/" exact element={<JobOrder />}>
      <Route index element={<JobOrderAccess />} />
      <Route path="manage/:action" element={<JobOrderManage />} />
      <Route path="view" element={<JobOrderView />} />
    </Route>
    <Route path="/ERP/shipment-plan/" exact element={<ShipmentPlan />}>
      <Route index element={<ShipmentPlanAccess />} />
      <Route path="manage/:action" element={<ShipmentPlanManage />} />
    </Route>
    <Route path="/ERP/fx-rate/" exact element={<FxRate />}>
      <Route index element={<FxRateAccess />} />
    </Route>
    <Route path="/ERP/purchase-order/" exact element={<PurchaseOrder />}>
      <Route index element={<PurchaseOrderAccess />} />
      <Route path="manage/:action" element={<PurchaseOrderManage />} />
      <Route path="view" element={<PurchaseOrderView />} />
    </Route>
    <Route path="/ERP/goods-receipt/" exact element={<GoodsReceipt />}>
      <Route index element={<GoodsReceiptAccess />} />
      <Route path="manage/:action" element={<GoodsReceiptManage />} />
      <Route path="qc" element={<GoodsReceiptQc />} />
      <Route path="tags" element={<GoodsReceiptTags />} />
      <Route path="view" element={<GoodsReceiptView />} />
      {/* AI อ่านใบส่งของ — ซ่อนไว้ ยังไม่มีเมนู */}
      <Route path="ai-scan" element={<GoodsReceiptAiScan />} />
    </Route>
    <Route path="/ERP/ju/" exact element={<Ju />}>
      <Route index element={<JuAccess />} />
      <Route path="manage/:action" element={<JuManage />} />
    </Route>
    <Route path="/ERP/fg-handover/" exact element={<FgHandover />}>
      <Route index element={<FgHandoverAccess />} />
      <Route path="manage/:action" element={<FgHandoverManage />} />
    </Route>
    <Route path="/ERP/requisition/" exact element={<Requisition />}>
      <Route index element={<RequisitionAccess />} />
      <Route path="manage/:action" element={<RequisitionManage />} />
    </Route>
    <Route path="/ERP/product-order/" exact element={<PDOrder />}>
      <Route index element={<PDAccess />} />
      <Route path="manage/:action" element={<PDManage />} />
      <Route path="view" element={<PDView />} />
    </Route>
    <Route path="/ERP/delivery-note/" exact element={<DeliveryNote />}>
      <Route index element={<DeliveryNoteAccess />} />
      <Route path="manage/:action" element={<DeliveryNoteManage />} />
    </Route>
    <Route path="/ERP/packing-list/" exact element={<PackingList />}>
      <Route index element={<PackingListAccess />} />
      <Route path="manage/:action" element={<PackingListManage />} />
    </Route>
    <Route path="/ERP/invoice/" exact element={<Invoice />}>
      <Route index element={<InvoiceAccess />} />
      <Route path="manage/:action" element={<InvoiceManage />} />
    </Route>
    <Route path="/ERP/proforma/" exact element={<Proforma />}>
      <Route index element={<ProformaAccess />} />
      <Route path="manage/:action" element={<ProformaManage />} />
    </Route>
  </>
);

